const PRICE_EPSILON = 0.005;
const DISPLAY_MODE_SHOW_DISCOUNT = 'show_discount';

export const normalizeUpc = (upc) => {
  if (upc === null || upc === undefined) return '';
  const value = String(upc).trim();
  return value && value !== '0' ? value : '';
};

export const normalizeMerchantId = (merchantId) =>
  String(merchantId ?? '').trim().toUpperCase();

export const priceBookKey = (merchantId, upc) =>
  `${normalizeMerchantId(merchantId)}|${normalizeUpc(upc)}`;

export const toMoney = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const amount = Number.parseFloat(value);
  return Number.isFinite(amount) && amount >= 0
    ? Math.round(amount * 100) / 100
    : null;
};

export const parseUnknownUpcFromError = (message) => {
  const match = /upc\s+([^\s:]+)\s*:\s*upc not found/i.exec(
    String(message ?? ''),
  );
  return match ? match[1] : null;
};

export const toPriceBookEntry = (row) => {
  const upc = normalizeUpc(row?.upc);
  const finalPrice = toMoney(row?.final_price);
  if (!upc || finalPrice === null) return null;

  return {
    upc,
    finalPrice,
    basePrice: toMoney(row?.base_price),
    priceBookId: row?.price_book_id ?? null,
    priceBookName: row?.price_book_name ?? '',
    displayMode: row?.online_display_mode ?? '',
  };
};

const changesPrice = (entry) =>
  entry?.priceBookId !== null &&
  entry?.priceBookId !== undefined &&
  entry.finalPrice !== null &&
  entry.basePrice !== null &&
  Math.abs(entry.finalPrice - entry.basePrice) >= PRICE_EPSILON;

export const getPriceBookPricing = (currentPrice, entry) => {
  const price = toMoney(currentPrice);
  if (price === null || !changesPrice(entry)) {
    return { applied: false, price, originalPrice: null };
  }

  return {
    applied: true,
    price: entry.finalPrice,
    originalPrice:
      entry.displayMode === DISPLAY_MODE_SHOW_DISCOUNT ? entry.basePrice : null,
  };
};

export const applyPriceBook = (item, entry) => {
  if (!item || typeof item !== 'object') return item;

  const { priceBook, ...rest } = item;
  const original = priceBook
    ? {
        price: priceBook.originalPrice,
        compare_price: priceBook.originalComparePrice,
      }
    : { price: item.price, compare_price: item.compare_price };
  const pricing = getPriceBookPricing(original.price, entry);

  if (!pricing.applied) {
    return priceBook ? { ...rest, ...original } : item;
  }

  return {
    ...rest,
    price: pricing.price.toFixed(2),
    compare_price:
      pricing.originalPrice !== null
        ? pricing.originalPrice.toFixed(2)
        : original.compare_price,
    priceBook: {
      id: entry.priceBookId,
      name: entry.priceBookName,
      finalPrice: entry.finalPrice,
      strikePrice: pricing.originalPrice,
      originalPrice: original.price,
      originalComparePrice: original.compare_price,
    },
  };
};

export const getCartLinePriceBookOriginal = (cartItem) => {
  const originalUnit = toMoney(cartItem?.priceBook?.strikePrice);
  const finalUnit = toMoney(cartItem?.priceBook?.finalPrice);
  if (
    originalUnit === null ||
    finalUnit === null ||
    Math.abs(originalUnit - finalUnit) < PRICE_EPSILON
  ) {
    return null;
  }

  const quantity =
    Number(cartItem?.aggregatedQuantity || cartItem?.selectedQuantity) || 1;
  return Math.round(originalUnit * quantity * 100) / 100;
};
